import { type RootState } from '../../stores/redux';
import { ModalId } from './modals.type';

export const getIsModalOpen = (state: RootState, modalId: ModalId) =>
  state.modals.current === modalId;

// Modals that won't hide callControls & inCallViewPanel
const excludedModalId = ModalId.AddToGroupCall;

export const getIsAnyModalOpen = (state: RootState) =>
  state.modals.current !== null && excludedModalId !== state.modals.current;
